import { render, staticRenderFns } from "./ClassClassification.vue?vue&type=template&id=9e25dbec&"
import script from "./ClassClassification.vue?vue&type=script&lang=js&"
export * from "./ClassClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports